import { PaymentMethod } from '../../store/methods/types';

export const getDefaultMethod = (list: PaymentMethod[]): PaymentMethod => list[0];

export const sortMethods = (m1: PaymentMethod, m2: PaymentMethod):
number => (m1.sort > m2.sort ? 1 : -1);
